import { render, staticRenderFns } from "./QuestionDelete.vue?vue&type=template&id=7a961f80&scoped=true&"
import script from "./QuestionDelete.vue?vue&type=script&lang=js&"
export * from "./QuestionDelete.vue?vue&type=script&lang=js&"
import style0 from "./QuestionDelete.vue?vue&type=style&index=0&id=7a961f80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a961f80",
  null
  
)

export default component.exports